import {useEffect} from 'react'
import {Navigate} from 'react-router-dom'
import {FullScreenLoader} from './RosFeatureProvider'
import {useRosFeatures} from './useRosFeatures'
import type {RosUiFeatureKey} from './types'

export function AccessAwareRoute({feature, children}: {feature: RosUiFeatureKey; children: React.ReactNode}) {
  const {state, enabled, reportUnavailable} = useRosFeatures()
  const allowed = enabled(feature)
  useEffect(() => {
    if (state.status === 'ready' && !allowed) reportUnavailable()
  }, [state.status, allowed, reportUnavailable])
  if (state.status === 'loading') return <FullScreenLoader />
  if (!allowed) return <Navigate to="/" replace />
  return <>{children}</>
}
